import React from "react";
import { useSelector } from "react-redux";
import MessagesNotification from "../../../../ui/messagesNotification/MessagesNotification";
import iconsList from "../../../../ui/icons/iconsList";
import pathRouts from "../../../../../enums/pathRoute";
import NavigateLink from "../../../../features/navigateLink/navigateLink";
import classes from "./WidgetDomainCard.module.css";

const WidgetDomainCard = ({ domain }) => {

    const { lang } = useSelector(state => state.translate);
    const domainName = domain?.text?.all?.[lang] || domain?.name;
    const imgSrc = domain.widgetImage;
    const color = domain.color || "#ccc";

    return (
        <NavigateLink link={`/${pathRouts.MYLEARNING}/domain/${domain?.nmmId}/${domain?.name}`} showLoadingPage={false}>
            <div className={classes.WidgetDomainCard} style={{ cursor: "pointer" }}>
                <div className={classes.ColorBar} style={{ backgroundColor: color }} />
                <div className={classes.DomainIconWrapper}>
                    {imgSrc ?
                        <img src={imgSrc} alt={domainName} className={classes.WidgetDomainImg} />
                        :
                        <div className={classes.WidgetDomainImg} />
                    }
                </div>
                <p className={classes.WidgetDomainTitle}>{domainName}</p>
            {domain?.hasUnreadMessages &&
                <MessagesNotification name={iconsList.messages} size="18px" />
            }
            </div>
        </NavigateLink>
    );
};

export default WidgetDomainCard;